import reset from '../assets/arrow-left.svg'
import { clearLocalData } from '../services/storage'
import { useTranslation } from 'react-i18next'
import { useContext } from 'preact/hooks'
import { AppContext } from '../main'

const Footer = () => {
  const { t } = useTranslation()
  const { playbookId } = useContext(AppContext)

  const refresh = () => {
    clearLocalData(playbookId)
    window.location.href = window.location.href
  }

  return (
    <div className="bg-gray-50 dark:bg-zinc-800 flex gap-1 items-center px-4 h-7 text-sm text-gray-500 dark:text-zinc-400 font-light">
      <button className="flex items-center gap-1 flex-1" onClick={refresh}>
        <img className="w-3 h-3" src={reset} />
        {t('footer.reset', 'Reset')}
      </button>
      <a href="https://linkando.com/playbooks" target="_blank">
        {t('footer.powered_by', 'Powered by Linkando')}
      </a>
    </div>
  )
}

export default Footer
